import { cn } from "@newxsystems/shared";
import { StratosCommonContent } from "../StratosCommonContent/StratosCommonContent";
import { StratosMedia } from "../StratosMedia/StratosMedia";
import type { IHeroSplitImageProps } from "./HeroSplitImage.props";

const contentSpacing = {
  tight: "p-6 md:p-9 lg:p-12",
  normal: "p-7 md:p-12 lg:p-16",
  loose: "p-9 md:p-16 lg:p-24",
} as const;

export const HeroSplitImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  spacing,
}: IHeroSplitImageProps) => {
  const hasContent = Boolean(eyebrow || heading || description || buttons?.length);

  if (!hasContent) {
    return (
      <StratosMedia
        aspectRatio={image.aspectRatio || "16:9"}
        className="w-full rounded-none"
        media={image.image}
        priority
        sizes="100vw"
      />
    );
  }

  return (
    <div className="grid min-w-0 overflow-hidden bg-night-flight md:min-h-[42rem] md:grid-cols-[0.9fr_1.1fr] max-w-440 mx-auto">
      <StratosMedia
        aspectRatio={image.aspectRatio || "16:9"}
        className="h-full min-h-80 min-w-0 w-full rounded-none md:order-2"
        imageClassName="h-full animate-[stratos-hero-reveal_1.2s_cubic-bezier(0.16,1,0.3,1)_both] object-cover"
        media={image.image}
        priority
        sizes="(min-width: 768px) 55vw, 100vw"
      />
      <StratosCommonContent
        alignment={alignment}
        buttons={buttons}
        className={cn("min-w-0 justify-center md:order-1", contentSpacing[spacing || "normal"])}
        description={description}
        eyebrow={eyebrow}
        heading={heading}
        headingAs="h1"
        headingClassName="text-5xl md:text-7xl lg:text-8xl"
        tone="dark"
      />
    </div>
  );
};

HeroSplitImage.displayName = "Content::HeroSplitImage";
